const NETFLIX_VALUES = {
  STANDARD: "268",
  PRIME: "269",
};
const TEXT_TYPES_CODES = {
  ORDINARY: "1",
  ABBREVIATED: "2",
  SHORT: "3",
  EXPLANATORY: "4",
  BRIEF: "5",
  MEDIUM: "6",
  REGULAR_WITH_VALUE: "7",
  ADDITIONAL_SHORT: "8",
  SHORT_EXPLANATORY: "9",
  LEGALS_EXPLANATORY: "10",
  FULL_EXPLANATORY: "11",
};
import { TITLE_MAX, TITLE_TV, TITLE_UNLIMITED } from "@/constants/catalogue";
import {
  DEVICE_TITLE,
  FUSION,
  INCLUDE_DEVICE_TITLE,
  NETFLIX_PRODUCT_OFFERING,
  NETFLIX_PRODUCT_OFFERING_NEW,
  NETFLIX_TEXTS,
  TRIO,
  TRIO_TEXTS,
} from "@/constants/constants";
import {
  getFirstProductByPoIdOnCertainProduct,
  getProductByPOId,
} from "@/utils/dataHandlers/ProductDataHandler";
import { capitalizeFirstLetter, convertToKebabCase } from "@/utils/htmlUtils";

export const updateObjectInArray = (array, itemIndex, newItemValues) => {
  return array.map((item, index) => {
    if (index !== itemIndex) {
      return item;
    }
    return {
      ...item,
      ...newItemValues,
    };
  });
};

export const findMatchByPatron = (patron, text) => {
  let bloques = text.split("\n\n");
  const resultados = [];
  
  bloques.forEach((bloque) => {
    const matches = bloque.matchAll(patron);
    for (const match of matches) {
      resultados.push(match[1]);
    }
  });

  return resultados;
};

export const normalizeExplanatoryText = (text) => {
  let patron = /- (.+)/g;

  let resultados = [];
  resultados = findMatchByPatron(patron, text);

  if (resultados.length < 1) {
    resultados = [];
    const bloques = text.split("\r\n");
    resultados.push(...bloques);
  }

  return resultados;
};

export const normalizeFullExplanatoryText = text => {
  let segments = null;
  let replaceText = null;
 if (/\n\n\n/.test(text) || /:\n\n/.test(text)) {
    if (/\n\n\n\n/.test(text)) {
      replaceText = text.replace(/\n\n\n\n/g, "\n\n");
    } else {
      replaceText = text.replace(/\n\n\n/g, "\n\n");
    }
    replaceText = replaceText.replace(/:\n\n/g, ":\n");
    segments = replaceText.split('\n\n');
  }else  {
    segments = text.split('\n\n');
  }
  const results = [];
  segments.forEach(segment => {
    if (segment.trim() !== '') {
      const lines = segment.split('\n');
      let title = lines.shift().trim(); // Extract and remove the title from the lines array
      if (title) {
        title = title.replace(/:$/, '');
      }
      const isTitleUpperCase = title === title.toUpperCase();
      const bullets = lines.map(line => {
        if (line.trim() !== '') {
          return line.trim().startsWith('-') ? line.trim().slice(1).trim() : line.trim();
        }
      }).filter(Boolean); // Filter out undefined bullets
      if (title.includes(DEVICE_TITLE) || title.includes(INCLUDE_DEVICE_TITLE)) {
        results.push({ title: capitalizeFirstLetter(INCLUDE_DEVICE_TITLE), literals: [capitalizeFirstLetter(title), ...bullets] });
      } else if (title && (title.toLowerCase().includes(TITLE_MAX) || title.toLowerCase().includes(TITLE_TV))) {
        results.push({ title: capitalizeFirstLetter(title.replace(':', '')), literals: bullets });
      } else if (title && title.toLowerCase().includes(TITLE_UNLIMITED)) {
        results.push({ title: capitalizeFirstLetter(title.replace(':', '')), literals: bullets });
      } else if (isTitleUpperCase) {
        results.push({ title: capitalizeFirstLetter(title.replace(':', '')), literals: bullets });
      } else {
        results.push({ title: null, literals: [title, ...bullets] });
      }
    }
  });
  return results;
};

export const getCatalogueProductOfferingNormalizer = (
  hiredProducts,
  productOffering,
  pikolin
) => {
  const productOfferingNormalized = productOffering;
  if (hiredProducts && Array.isArray(hiredProducts)) {
    const { id, texts } = productOffering;
    const productSelected = getProductByPOId(hiredProducts, id);
    if (productSelected) {
      const { productType } = productSelected;
      if (productType === FUSION && !pikolin) {
        const netflixProduct = getFirstProductByPoIdOnCertainProduct(
          productSelected,
          [NETFLIX_PRODUCT_OFFERING, NETFLIX_PRODUCT_OFFERING_NEW]
        );
        if (netflixProduct) {
          const { characteristics } = netflixProduct;
          if (characteristics && Array.isArray(characteristics)) {
            const netflixModality = characteristics.find(
              (char) =>
                char.valueId === NETFLIX_VALUES.STANDARD ||
                char.valueId === NETFLIX_VALUES.PRIME
            );
            const ordinaryTextIndex = texts.findIndex(
              (text) => text.typeId === TEXT_TYPES_CODES.ORDINARY
            );
            if (netflixModality && ordinaryTextIndex !== -1) {
              let { text } = texts[ordinaryTextIndex];
              if (text) {
                if (netflixModality.valueId === NETFLIX_VALUES.STANDARD) {
                  text = `${text} ${NETFLIX_TEXTS.X2}`;
                } else if (netflixModality.valueId === NETFLIX_VALUES.PRIME) {
                  text = `${text} ${NETFLIX_TEXTS.X4}`;
                }
                productOfferingNormalized.texts = updateObjectInArray(
                  texts,
                  ordinaryTextIndex,
                  { text }
                );
              }
            }
          }
        }
      } else if (productType === TRIO) {
        const ordinaryTextIndex = texts.findIndex(
          (text) => text.typeId === TEXT_TYPES_CODES.ORDINARY
        );
        if (ordinaryTextIndex !== -1) {
          let { text } = texts[ordinaryTextIndex];
          if (text) {
            text = `${text} ${TRIO_TEXTS.AND_TV}`;
            productOfferingNormalized.texts = updateObjectInArray(
              texts,
              ordinaryTextIndex,
              { text }
            );
          }
        }
        const shortExplanatoryTextIndex = texts.findIndex(
          (text) => text.typeId === TEXT_TYPES_CODES.SHORT_EXPLANATORY
        );
        if (shortExplanatoryTextIndex !== -1) {
          let { text } = texts[shortExplanatoryTextIndex];
          if (text) {
            text = `${text} ${TRIO_TEXTS.TV}`;
            productOfferingNormalized.texts = updateObjectInArray(
              productOfferingNormalized.texts,
              shortExplanatoryTextIndex,
              { text }
            );
          }
        }
      }

      const explanatoryTextIndex = texts.findIndex(
        (text) => text.typeId === TEXT_TYPES_CODES.EXPLANATORY
      );

      const resultados = explanatoryTextIndex !== -1 && normalizeExplanatoryText(
        texts?.[explanatoryTextIndex]?.text
      );

      const fullExplanatory = explanatoryTextIndex !== -1 && normalizeFullExplanatoryText(texts?.[explanatoryTextIndex]?.text)

      productOfferingNormalized.texts = updateObjectInArray(
        texts,
        explanatoryTextIndex,
        { text: resultados, completeText: fullExplanatory }
      );

    }
  }
  return productOfferingNormalized;
};
